var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var Svg24IcInboxBranchLink = function Svg24IcInboxBranchLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.599V8.863c0-1.095-.945-1.932-2.182-1.932h-6.182L12.4 5.258c-.146-.13-.364-.258-.582-.258H8.182C6.945 5 6 5.837 6 6.931v9.138C6 17.163 6.945 18 8.182 18h1.909",
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.075 18H4.176C2.943 18 2 17.099 2 15.92V6.08C2 4.901 2.943 4 4.176 4h3.627c.218 0 .435.139.58.277L9 5.18",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12c0 1.133.867 2 2 2s2-.867 2-2-.867-2-2-2-2 .867-2 2zM12 18.2a3.2 3.2 0 0 1 3.2-3.2h3.6a3.2 3.2 0 0 1 3.2 3.2.8.8 0 0 1-.8.8h-8.4a.8.8 0 0 1-.8-.8z",
    fill: "#BDBDBD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(Svg24IcInboxBranchLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/24_ic_inbox_branch_link.f77323fc729bbc6928f91223394062e6.svg";